import Button, { ButtonProps } from "../button";
import { useTranslations } from "use-intl";
import { CloseOutlined } from "@ant-design/icons";

export function CancelButton({ children, ...props }: ButtonProps) {
  const t = useTranslations("Common");

  return (
    <Button icon={<CloseOutlined />} danger {...props}>
      {children ?? t("Cancel")}
    </Button>
  );
}
